module.exports = __webpack_public_path__ + "img/gold-coin2-bg.bb816372.png";